module.exports = __webpack_public_path__ + "img/door.aaa06610.svg";